import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import CadastroEmpresaForm from '../cadastros/CadastroEmpresaForm';
import { clientesTenantApi } from '../../api/clientes';
import { COLORS } from '../../theme';

export default function ClientesList() {
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [registroAberto, setRegistroAberto] = useState(undefined);

  const carregar = () => clientesTenantApi.listar(busca ? { busca } : {}).then(setClientes).catch(() => {});
  useEffect(() => { carregar(); }, [busca]); // eslint-disable-line

  const alternarAtivo = async (cliente) => {
    const acao = cliente.ativo ? 'desativar' : 'reativar';
    if (!window.confirm(`Tem certeza que quer ${acao} o cliente "${cliente.nome_fantasia}"?`)) return;
    await clientesTenantApi.atualizar(cliente.id, { ativo: cliente.ativo ? 0 : 1 });
    carregar();
  };

  if (registroAberto !== undefined) {
    return (
      <CadastroEmpresaForm
        titulo="Cliente"
        api={clientesTenantApi}
        registroId={registroAberto}
        onVoltar={() => { setRegistroAberto(undefined); carregar(); }}
        onSalvo={carregar}
      />
    );
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <Input placeholder="Buscar por nome ou CNPJ/CPF..." value={busca} onChange={e => setBusca(e.target.value)} style={{ width: 320 }} />
          <Btn onClick={() => setRegistroAberto(null)}>+ Novo Cliente</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Nome Fantasia</th>
              <th style={{ padding: 10 }}>CNPJ/CPF</th>
              <th style={{ padding: 10 }}>Telefone</th>
              <th style={{ padding: 10 }}>Cidade/UF</th>
              <th style={{ padding: 10 }}>Status</th>
              <th style={{ padding: 10 }}></th>
            </tr>
          </thead>
          <tbody>
            {clientes.map(c => (
              <tr key={c.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10, cursor: 'pointer' }} onClick={() => setRegistroAberto(c.id)}>{c.nome_fantasia}</td>
                <td style={{ padding: 10 }}>{c.cnpj_cpf || '-'}</td>
                <td style={{ padding: 10 }}>{c.telefone1 || '-'}</td>
                <td style={{ padding: 10 }}>{c.end_principal_cidade ? `${c.end_principal_cidade}/${c.end_principal_uf || ''}` : '-'}</td>
                <td style={{ padding: 10 }}>{c.ativo ? <Badge tom="sucesso">Ativo</Badge> : <Badge tom="perigo">Inativo</Badge>}</td>
                <td style={{ padding: 10, display: 'flex', gap: 8 }}>
                  <Btn tamanho="sm" variante="ghost" onClick={() => setRegistroAberto(c.id)}>Editar</Btn>
                  <Btn tamanho="sm" variante={c.ativo ? 'danger' : 'secondary'} onClick={() => alternarAtivo(c)}>
                    {c.ativo ? 'Desativar' : 'Reativar'}
                  </Btn>
                </td>
              </tr>
            ))}
            {clientes.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum cliente cadastrado ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
